class SingleCourse {
	constructor () {
		this.titleCourse = document.querySelector('.breadcrumb li:last-child span')
		this.datesCourse = document.getElementById('deadlines')

		this.formSelectCourse = document.getElementById('wybierztermin')
		this.formInputTitleCourse = document.getElementById('nazwakursu')
	}

	init () {
		this.formInputTitleCourse.attributes.value.textContent = this.titleCourse.innerText
		this.formInputTitleCourse.innerHTML = this.titleCourse.innerText
		if(this.datesCourse) {
			this.formSelectCourse.innerHTML = this.datesCourse.innerHTML
			this.datesCourse.addEventListener('change', () => {
				this.selectDates(this.datesCourse)
			})
		}

		this.formSelectCourse.addEventListener('change', () => {
			this.selectDates(this.formSelectCourse)
		})

	}

	selectDates (el) {
		this.formSelectCourse.value = el.value
		this.datesCourse.value = el.value

	}

}

document.addEventListener('DOMContentLoaded', () => {
	new SingleCourse().init()
})



// WEBPACK FOOTER //
// ./templates/rekinysukcesu/js/extensions/single_course/script.js